import React, {useState, useMemo} from "react";
import {Stack, Box, Typography, dialogClasses, useTheme, alpha} from '@mui/material'
import FlipCard from "../FlipCard/FlipCard";
import {useTranslation} from "react-i18next";
import RpIcon from "../RpIcon";
import {useConfirm} from "material-ui-confirm";
import {useBoolean} from "ahooks";
import {CircularProgress as Loading} from "@mui/material";
import CopyButton from "@/components/CopyButton";
import {useRequest} from "ahooks";
import {requestCardInfo} from '@/services'

import {BUY_CARD_STATUS, CARD_STATUS, CARD_STRING_TYPE, CARD_STRING_TYPE as CARD_TYPE} from "@/constant/Constant.ts";

import TwoFAModal from "@/components/TwoFAModal";

import useSettings from "@/hook/useSettings";

import "./index.less";
import {clearTaskRule, setTaskRuleParams} from "@/redux/slices/user";
import {VerifyAction} from "@/constant/VerifyConstant";
import {enqueueSnackbar} from "notistack";

interface Props {
  cardItem: CardInfo;
  convert?: boolean;
  isDelete?: boolean;
}

export interface CardInfo {
  cardId: string;
  cardType: number;
  ibanCode: string;
  balance: string;
  available: string;
  freeze: string;
  last4: string;
  cardholderName: string;
  physicalCardStatus: number;
  cardStatus: string;
  lossStatus: number;
  lockStatus: number;
  lockExpireTime: number;
  kycStatus: number;
  openStatus: number;
  isActive: number;
  pinSet: number;
  activeTime: number;
  isEnable: number;
  firstName: string;
  lastName: string;
  lastBalanceTime: number;
  label: string;
  cardDesignJson: null | Record<string, string>;
  deliverStatus: number;
  deliverNo: string;
  deliverTime: number;
}

const RightTopContent = (card) => {
  // if (card.)
}

export default function RedotpayCard({cardItem, convert, isDelete}: Props) {
  const theme = useTheme();
  const {settings} = useSettings();
  const confirm = useConfirm();

  const requestCardInfoReq = useRequest(async (params, cardId) => {
    const res = await requestCardInfo({...params}, cardId)
    return res
  }, {manual: true})

  const [isConvert, setIsConvert] = useState(!!convert);
  const [cardBackInfo, setCardBackInfo] = useState();
  const [cardBackLoading, setCardBackLoading] = useState(false);

  const [signOpen, signOpenOperate] = useBoolean(false);

  const [twoFAModalShow , twoFAModalShowOperate] = useBoolean(false);

  const {t} = useTranslation();
  const cardHoldName = useMemo(() => {
    if (!cardItem?.cardholderName) {
      return "";
    }
    const longName = cardItem?.cardholderName?.length > 15;
    if (longName) {
      const names = cardItem?.cardholderName?.split(",");
      if (names.length === 2) {
        return `${names[0]}\n${names[1]}`;
      }
    }
    return cardItem?.cardholderName;
  }, [cardItem]);

  const _onViewCardInfo = (evt) => {
    evt.stopPropagation();
    if (isFrozen) {
      return
    }
    if (cardItem.lossStatus == 1) {
      enqueueSnackbar(t('card_is_loss'), { variant: 'error' })
      return;
    }
    if (!cardBackInfo) {
      clearTaskRule()
      setTaskRuleParams(({
        action: VerifyAction.CARD_BACK_INFO,
      }))
      twoFAModalShowOperate.setTrue()
    } else {
      setCardBackInfo(null);
    }
  };

  const getCardColor = (cardType) => {
    if (cardType == 1) {
      return theme.palette.card.cardgradientColorLight
    }
    return theme.palette.card.cardgradientColorDark
  }

  const isPending = useMemo(() => {
    if (!cardItem) {
      return false
    }
    if (cardItem?.cardStatus == null || cardItem?.cardStatus == BUY_CARD_STATUS.PENDING) {
      return true
    }
    if (cardItem?.cardType == CARD_STRING_TYPE.PHYSICAL) {
      return cardItem?.reissueStatus == 1
    }
    return false
  }, [cardItem])

  const isFrozen = useMemo(() => {
    if (!cardItem) {
      return false
    }
    if (cardItem?.cardStatus == CARD_STATUS.FROZEN) {
      return true
    }
    return false
  }, [cardItem])

  const rightCornerText = useMemo(() => {
    if (isFrozen) {

      return<Stack direction="row" alignItems="center">
        <RpIcon
          color={theme.palette.warning.main}
          icon="a-Property1Outline15-24PXProperty2yuandianzhanwei" />
        <Typography color={theme.palette.warning.main}>{t('frozen')}</Typography>
      </Stack>

    }
    if (isPending) {
      return t('pending')
    }

    return ''
  }, [])
    // /images/card/flip.svg#svgView(preserveAspectRatio(none))
  return (
    <>
      <FlipCard disabled={true} flipped={isConvert}>
        {/* front */}
        <Box
          sx={{
            background: getCardColor(cardItem?.cardType),
            padding: '16px' // `${theme.typography.pxToRem(16)}`
          }}
          // card-${cardItem.cardType}
          className={`redotpay-card card-${cardItem?.cardType}`}
          onClick={() => setIsConvert(true)}
        >
          <Stack direction="row" justifyContent="space-between">
            <Box className="card-logo">
              {/* <RpIcon icon="logo" size={32}/> */}
            </Box>
            <Typography
            sx={theme => {
              return {
                fontSize: '12px' //theme.typography.pxToRem(12),
              }
            }}
            >{
              rightCornerText || cardItem?.label
            }</Typography>
          </Stack>
          <Stack direction="row" alignItems="center" gap={'20px'} className="card-info">
            {cardBackInfo ? (
              <Typography
                sx={{
                  fontSize: theme.typography.pxToRem(20),
                  textDecoration: isDelete ? 'line-through' : 'unset'
              }}
                component="div">{cardBackInfo.pan}</Typography>
            ) : (
              <>
                <Typography
                  sx={{
                    fontSize: '20px !important', //theme.typography.pxToRem(20),
                    textDecoration: isDelete ? 'line-through' : 'unset'
                  }}
                >{`\u2022\u2022\u2022\u2022 \u2022\u2022\u2022\u2022 \u2022\u2022\u2022\u2022 ${cardItem?.last4 ?? "\u2022\u2022\u2022\u2022"}`}</Typography>

              </>)}

            {cardBackInfo ? (
              <span
                onClick={(evt) => evt.stopPropagation()}
              >
              <CopyButton value={cardBackInfo.pan} />
            </span>
            ) : null}

            {requestCardInfoReq?.loading ? (
              <Loading size={18} sx={theme => {
                return {color: theme.palette.brand.main}
              }}/>
            ) : (
              <span onClick={_onViewCardInfo}>
              {cardItem?.last4 ? (
                cardBackInfo ? (
                  <>
                    <RpIcon icon="eye_open" color={isFrozen ? alpha(theme.palette.background.default, 0.4) : ''} size={24}/>
                  </>
                ) : (
                  <>
                    <RpIcon color={isFrozen ? alpha(theme.palette.background.default, 0.1) : ''} icon="eye_close" size={24}/>
                  </>
                )
              ) : <></>}
            </span>
            )}
          </Stack>
          <Stack direction="row" justifyContent="space-between" className="card-bottom">
            <img
              style={{
                width: theme.typography.pxToRem(24),
                // height: theme.typography.pxToRem(24),
                display: "block",
              }}
              src="/images/card/flip.png" />
              <Box className="visa-logo"></Box>
          </Stack>
        </Box>
        {/* back end */}
        <div
          className={`redotpay-card card-${cardItem?.cardType}`}
          onClick={() => setIsConvert(false)}
        >
          <Stack direction="row" justifyContent="space-between" className="card-type">
            <span></span>
            <span>{cardItem?.ibanCode}</span>
          </Stack>
          <div className="card-mask"></div>
          <div className="card-sign">
            <div>{cardHoldName}</div>
            <div className="flex md:text-[14px] text-[3.26vw]">
            <span className="md:me-[4.65w] me-[20px]">
              {t("valid_thru")} &nbsp;
              {cardBackInfo ? cardBackInfo.expiryDate : "\u2022\u2022\u2022"} &nbsp;
            </span>
              <span>
              CVV {cardBackInfo ? cardBackInfo.cvv : "\u2022\u2022\u2022"}
            </span>
            </div>
          </div>
        </div>
      </FlipCard>
      <TwoFAModal successCallback={() => {
        if (cardItem?.cardId) {
          requestCardInfoReq.runAsync({}, cardItem.cardId).then(res => {
            setCardBackInfo(res)
            twoFAModalShowOperate.setFalse()
          })
        }

      }} open={twoFAModalShow} onClose={twoFAModalShowOperate.setFalse}/>
    </>

  );
}
